import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { queryStringChanged } from "../../features/tasks/tasksSlice";
import Header from "../home/Header";
import Sidebar from "../home/sidebar/Sidebar";
import TaskList from "../home/tasks/TasksList";

export default function Home() {
  const dispatch = useDispatch()

  useEffect(()=>{
    return function cleanup() {
      dispatch(queryStringChanged(''))    
    };
  })
  return (
    <>
      <Sidebar />
      <div className="lg:pl-[16rem] 2xl:pl-[23rem]">
        <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
          <Header/>

          <TaskList />
        </main>
      </div>
    </>
  )
}